import { logEvent } from "firebase/analytics";
import { analytics } from "../../firebase/firebase";

export const trackOnboardingStep = (step, userId = "guest") => {
    logEvent(analytics, step, {
        userId: userId,
        timestamp: Date.now(),
    });
};
